import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SocketContext from "../../context/SocketContext";

export default function LivePlMaster({ item, total, isDollar }) {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);
  const [pf, setPf] = useState(0);

  const exchangeType =
    item.type === "us_stock" ||
    item.type === "index" ||
    item.type === "crypto_future" ||
    item.type === "comex_future" ||
    item.type === "forex_future" ||
    item.type === "dgcx";

  useEffect(() => {
    if (!item?.symbol_id) return;

    const socketTrade = (data) => {
      if (!data) return;

      const rate = parseFloat(item.rate);
      const qty = parseFloat(item.qty);
      const dollarRate = parseFloat(item.dollar_rate) || 1; // default 1 if not available

      let profit = 0;

      if (item.buy_sell === 0) {
        const bid = parseFloat(data.Bid);
        const ltp = parseFloat(data.LTP);
        const price =
          !isNaN(bid) && bid > 0 ? bid : !isNaN(ltp) && ltp > 0 ? ltp : 0;
        profit = (price - rate) * qty;
      } else if (item.buy_sell === 1) {
        const ask = parseFloat(data.Ask);
        const ltp = parseFloat(data.LTP);
        const price =
          !isNaN(ask) && ask > 0 ? ask : !isNaN(ltp) && ltp > 0 ? ltp : 0;
        profit = (rate - price) * qty;
      }

      // ✅ Apply dollar_rate for specific types
      if (isDollar === 0) {
        if (exchangeType) {
          profit *= dollarRate;
        }
      }

      setPf(parseFloat(profit));
    };

    socket.emit("giverate", item.symbol_id);
    socket.on("trade" + item.symbol_id, socketTrade);

    return () => {
      socket.off("trade" + item.symbol_id, socketTrade);
    };
  }, [socket, item]);

  // Dispatch only when pf or total changes
  useEffect(() => {
    const totalAdminPf =
      (parseFloat(pf) * parseFloat(item.admin_sharing || 0)) / 100;

    dispatch({
      type: "PFMASTER",
      symbol_id: item.id,
      totaladmin_pf: totalAdminPf,
      pf: pf,
      total: total,
    });
  }, [pf, total, dispatch, item]);

  return <div />;
}
